import styled from '@emotion/styled';

import { maxWidthAndCenter } from '@styles';

const ContactLocationsContainer = styled.div<{ length: number }>`
  .contact_locations__content {
    ${maxWidthAndCenter}
  }

  .contact_locations__heading {
    padding: 3rem 0 2rem;
    text-align: center;
    font-size: 2rem;
    font-weight: 900;
    text-transform: uppercase;
    color: var(--orange);
  }

  .contact_locations__content__row {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    padding: 0 0 2rem;
  }

  .contact_locations__content__item {
    max-width: ${(props) => `${100 / props.length}%`};
    padding: 0 1rem;
    text-align: center;

    h3 {
      padding: 0 0 1rem;
      text-transform: uppercase;
      font-weight: 900;
      color: var(--orange);
      cursor: pointer;

      &:hover {
        text-decoration: underline;
        text-decoration-thickness: 0.2rem;
      }
    }

    pre {
      font-weight: 500;
      color: var(--blue);
    }
  }

  @media screen and (max-width: 1152px) {
    .contact_locations__content__row {
      flex-wrap: wrap;
      flex-direction: row;
      align-items: start;
    }

    .contact_locations__content__item {
      max-width: 100%;

      pre {
        margin: 1rem 0 1.5rem;
      }
    }
  }

  @media screen and (max-width: 640px) {
    .contact_locations__heading {
      padding: 3rem 2rem 2rem;
    }
  }
`;

export { ContactLocationsContainer };
